import {route, trans, widget} from "../../../modulesCompiler";
import {Link} from "react-router-dom";
import React from "react";
import {Menu} from "react-feather";


function PublicHeaderNav() {

    return (
        <>
            {widget("categories.CategoriesDrawer", {
                button: <button className="btn btn-secondary ps-2 ps-md-4 pe-2 pe-md-4 pt-1 pt-md-2 pb-1 pb-md-2
                  d-none d-md-block me-md-5 me-3 fw-bold nowrap">
                    <Menu /> KATEGORIJE
                </button>
            })}

            <div className="me-md-5 nowrap">
                <Link to={route("public.index")}>{trans("naslovna")}</Link>
            </div>
            <div className="me-md-5 nowrap">
                <Link to={route("public.about")}>{trans("o nama")}</Link>
            </div>
            <div className="me-md-5 nowrap">
                <Link to={route("products.action")}>Akcija</Link>
            </div>
            <div className="me-md-5 nowrap">
                <Link to={route("products.new")}>Novo</Link>
            </div>
            <div><Link to={route("public.contact")}>{trans("kontakt")}</Link></div>
        </>
    )
}
export default PublicHeaderNav;